import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const ClubModal = ({ isOpen, onClose, onSubmit, result, loading, subDistricts = [] }) => {
    const [formData, setFormData] = useState(result || {});

    useEffect(() => {
        setFormData(result || {});
    }, [result, isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    if (!isOpen) return null;

    const inputClasses = "w-full px-5 py-3.5 rounded-xl border border-slate-100 bg-slate-50/50 focus:bg-white focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500 outline-none transition-all text-sm font-bold text-slate-900 placeholder:text-slate-400 placeholder:font-normal";
    const labelClasses = "block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1";

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/10 backdrop-blur-md animate-in fade-in duration-300" onClick={onClose}>
            <div className="bg-white rounded-3xl w-full max-w-lg overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.1)] border border-slate-100 transform transition-all animate-premium" onClick={(e) => e.stopPropagation()}>
                <div className="p-8 border-b border-slate-50 flex justify-between items-center bg-white">
                    <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight">
                        {formData.id || formData.lion_ID ? 'Modify Club Identity' : 'Initialize Club Asset'}
                    </h2>
                    <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-xl bg-slate-50 text-slate-400 hover:text-slate-900 hover:bg-slate-100 transition-all">
                        <FaTimes size={18} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-8 space-y-6">
                    <div className="grid grid-cols-1 gap-6">
                        <div>
                            <label className={labelClasses}>Tactical Lion ID</label>
                            <input
                                type="number"
                                value={formData.lion_ID || ''}
                                onChange={(e) => setFormData({ ...formData, lion_ID: e.target.value })}
                                required
                                placeholder="Unique ID (e.g. 123456)"
                                className={inputClasses}
                                disabled={formData.id || formData.lion_ID}
                            />
                        </div>
                        <div>
                            <label className={labelClasses}>Core Club Name</label>
                            <div className="relative">
                                <span className="absolute left-5 top-1/2 -translate-y-1/2 text-sm font-bold text-slate-400 pointer-events-none">Leo Club of</span>
                                <input
                                    type="text"
                                    value={formData.name?.replace(/^Leo Club of\s+/i, '') || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, name: `Leo Club of ${value.trim()}` });
                                    }}
                                    required
                                    placeholder="Location/Identity"
                                    className={`${inputClasses} pl-[105px]`}
                                />
                            </div>
                        </div>
                    </div>

                    {subDistricts.length > 0 && (
                        <div>
                            <label className={labelClasses}>Assigned Sub-Sector</label>
                            <select
                                value={formData.sub_district_id || ''}
                                onChange={(e) => setFormData({ ...formData, sub_district_id: e.target.value })}
                                required
                                className={inputClasses}
                            >
                                <option value="">Select Tactical Sub-District</option>
                                {subDistricts.map((sd) => (
                                    <option key={sd.id} value={sd.id}>{sd.name}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="grid grid-cols-2 gap-6">
                        <div>
                            <label className={labelClasses}>Tier Category</label>
                            <select
                                value={formData.category || ''}
                                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                required
                                className={inputClasses}
                            >
                                <option value="">Select Tier</option>
                                <option value="Alpha">Alpha</option>
                                <option value="Omega">Omega</option>
                            </select>
                        </div>
                        <div>
                            <label className={labelClasses}>Unit Type</label>
                            <select
                                value={formData.type || ''}
                                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                required
                                className={inputClasses}
                            >
                                <option value="">Select Type</option>
                                <option value="School">School</option>
                                <option value="Community">Community</option>
                                <option value="University">University</option>
                            </select>
                        </div>
                    </div>

                    <div className="flex gap-4 pt-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="flex-1 py-4 text-slate-400 font-bold text-[10px] uppercase tracking-widest hover:text-slate-900 transition-colors"
                        >
                            Abort
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="flex-[2] py-4 bg-indigo-600 text-white rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-lg shadow-indigo-600/20 hover:bg-indigo-700 hover:-translate-y-0.5 transition-all disabled:opacity-50"
                        >
                            {loading ? 'Processing...' : (formData.id || formData.lion_ID ? 'Commit Changes' : 'Initialize Unit')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ClubModal;
